import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 0v18l4-4h14V0H0zm5 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm7 4.797c-.852.597-1.883.953-3 .953s-2.148-.356-3-.953v-2.07c.684.919 1.769 1.523 3 1.523s2.316-.604 3-1.523v2.07zM12 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
  </svg>
);

export default SvgComponent;
